import {
    getPromotionTool,
    getPromotionToolSrc,
    PromotionToolEnum,
} from '@/components/images/base64/PromotionTool';
import { ScreenContext } from '@/contexts/ScreenContext';
import { usePromotionTool } from '@/hooks/popup/promotiontool/usePromotionTool';
import { useIsLobby } from '@/hooks/useIsLobby';
import { RwdTypography } from '@/modules/rwdGame/components/RwdTypography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AudioPlayContext } from '../../../../contexts/AudioPlayContext';
import { RootState } from '../../../../store/store';
import { calcLowHigh, numberFormat } from '../../../../utils/commonFunc';
import { getPromotionToolState } from '../../../main/selector';
import { promotionToolSliceActions } from '../../../main/slice/promotiontool/promotionTool';
import { PromotionPage } from '../../../popup/promotiontool/components/PromotionDialog';
import { popupSliceActions } from '../../slice';
import { PromotionBubble } from './PromotionBubble';
import './index.scss';

type PromotionIndicatorProps = {
    refHeight?: number | undefined;
};
export const PromotionIndicator = (props: PromotionIndicatorProps) => {
    const { eventEnded } = usePromotionTool();
    const { isLandscape } = useContext(ScreenContext);
    const [screenRatio, setScreenRatio] = useState<number>(1);
    const dispatch = useDispatch();
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { Point } = useSelector((state: RootState) =>
        getPromotionToolState(state)
    );
    const [eventPoint, setEventPoint] = useState<string>(numberFormat(0, 2));
    const defaultHeight = 20;
    // const [fixedHeight, setFixedHeight] = useState<number>(defaultHeight);
    const isLobby = useIsLobby();

    useEffect(() => {
        setEventPoint(numberFormat(calcLowHigh(Point) / 100, 2));
    }, [Point]);

    useEffect(() => {
        if (props.refHeight) {
            setScreenRatio(
                (props.refHeight / defaultHeight) * (isLandscape ? 0.95 : 0.85)
            );
        } else {
            setScreenRatio(1);
        }
    }, [isLandscape, props.refHeight]);

    // useEffect(() => {
    //     setFixedHeight(defaultHeight * screenRatio);
    // }, [screenRatio]);

    const onClickButton = () => {
        if (eventEnded()) {
            dispatch(
                popupSliceActions.open('promotion_tool.popup_event_ended')
            );
            return;
        }

        dispatch(promotionToolSliceActions.updatePage(PromotionPage.Gacha));
        dispatch(promotionToolSliceActions.isOpenDialog(true));
        playButtonAudio();
    };

    return (
        <>
            {isLobby && (
                <Button
                    className="promotion-indicator-button-lobby"
                    onClick={onClickButton}
                >
                    <Box className="button-detail">
                        <Box className="button-icon">
                            {getPromotionTool(PromotionToolEnum.event_gem)}
                        </Box>
                        <Typography className="button-text">
                            {eventPoint}
                        </Typography>
                    </Box>
                    <PromotionBubble
                        direction="bottom"
                        spacing={-2}
                        ratio={screenRatio}
                        color={'#000000'}
                    />
                </Button>
            )}
            {!isLobby && (
                <Button
                    className="promotion-indicator-button"
                    onClick={onClickButton}
                >
                    <Box className="button-box">
                        <Box className="button-icon">
                            <img
                                key={
                                    'PromotionTool_' +
                                    PromotionToolEnum.event_gem
                                }
                                className="PromotionTool"
                                src={getPromotionToolSrc(
                                    PromotionToolEnum.event_gem
                                )}
                                height={'84.21052631578947%'}
                                width={'100%'}
                            />
                        </Box>
                        <RwdTypography
                            stepIndex={2}
                            landscapeStepIndex={3}
                            sx={{
                                color: 'white',
                            }}
                        >
                            {eventPoint}
                        </RwdTypography>
                    </Box>
                    <PromotionBubble
                        direction="left"
                        spacing={5}
                        ratio={screenRatio}
                        color={'#000000'}
                    />
                </Button>
            )}
        </>
    );
};
